export const modifierList = ['editorial-premium', 'narrow-article', 'slim', 'bg-dark', 'sticky'];
